import { Location } from '@angular/common';
import { AfterContentChecked, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from './shared/services/auth.service';
import { BloqueoModuloService } from './shared/services/bloqueo-modulo.service';
import { ConsoleService } from './shared/services/console.service';
import { DatesService } from './shared/services/dates.service';
import { FileDownloadService } from './shared/services/file-download.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']

})

export class AppComponent implements OnInit, OnDestroy, AfterContentChecked {
  login = false;
  specialPage = false;

  // private readonly ACTIVE_TABS_STORAGE_KEY = StorageVariable.ACTIVE_TABS_STORAGE_KEY;
  private codigoModuloActualmenteBloqueado: number | null = null;
  private bloqueoStatusSub: Subscription;

  private currentUrl = '';
  private log: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private location: Location,
    private bloqueoVistaService: BloqueoModuloService,
    private dateService: DatesService,
    private fileService: FileDownloadService,
    private clog: ConsoleService,
  ) {
    this.log = this.clog.log('ROOT');
  }
  ngOnInit(): void {
    // this.registrarTabBrowser();
    this.registrarBloqueoModulo();
    this.router.events.subscribe((route: any) => {
      this.currentUrl = route.url;
    });
  }

  ngAfterContentChecked(): void {
    this.login = this.router.url === '/login';
  }

  ngOnDestroy(): void {
    if (this.bloqueoStatusSub) {
      this.bloqueoStatusSub.unsubscribe();
    }
  }

  // EVENTO AL CERRAR PESTAÑA O EL NAVEGADOR
  @HostListener('window:beforeunload')
  onExitBrowser() {
    // FLAGS: SI ESTA DESCARGANDO UN ARCHIVO NO CERRAR SESION
    if (this.fileService.isDownloadingFile) return;
    // COMENTAR SI ESTAMOS EN DESARRLLO, PARA QUE NO LES MOLESTE CADA VEZ QUE RECARGAN LA PAGINA
    this.authService.logoutSendBeacon();
    if (!!this.codigoModuloActualmenteBloqueado) {
      this.bloqueoVistaService.liberarBloqueoAlSalirDelNavegador(this.codigoModuloActualmenteBloqueado);
    }
  }

  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    console.log('visibilityState', document.visibilityState);

    if (document.visibilityState === 'visible') {
      // Intenta refrescar si ya pasó el punto de refresco o estamos cerca
      this.authService.tryRefreshToken().subscribe({
        next: () => console.log(`${this.dateService.getDateNowConsole()}: onVisibilityChange - tryRefreshToken - Token refrescado exitosamente`),
        error: () => console.error(`${this.dateService.getDateNowConsole()}: onVisibilityChange - tryRefreshToken - Fallo al refrescar token`),
        complete: () => console.log(`${this.dateService.getDateNowConsole()}: onVisibilityChange - tryRefreshToken - Completado Refresco Token`)
      });
    }
  }

  @HostListener('window:pageshow', ['$event'])
  onPageShow(e: PageTransitionEvent) {
    console.log('pageshow', e);
    // Volviendo de bfcache: revalida
    this.authService.tryRefreshToken().subscribe();
  }

  goBack(): void {
    this.location.back();
  }

  // DEJO OBSOLETO, PORQUE QUIERO SI O SI QUE SE BORRE LA INFORMACION CUANDO SE CIERRE EL NAVEGADOR O CUANDO SE RECARGA LA APLICACION
  private cerrarSesion() {
    const navigationEntries = performance.getEntriesByType('navigation');
    if (navigationEntries.length === 0) return;
    const navEntry = navigationEntries[0] as PerformanceNavigationTiming;
    const isDev = false;
    console.log('Cerrar sesion: ', isDev, navEntry.type);
    if (!isDev) {
    } else if (navEntry.type !== 'reload') { // navEntry.type !== 'navigate'
      this.authService.logoutSendBeacon();
    }
  }

  private registrarBloqueoModulo() {
    // NOS SUBSCRIBIMOS AL ESTADO DEL BLOQUEO
    this.bloqueoStatusSub = this.bloqueoVistaService.estadoBloqueo$.pipe(
      filter(estado => !!estado && estado.exito) // SOLO TOMAMOS LOS ESTADOS QUE SON EXITOSOS
    ).subscribe(estadoBloqueo => {
      this.log('ESTADO DEL BLOQUEO', estadoBloqueo);
      if (estadoBloqueo && estadoBloqueo.exito) {
        this.codigoModuloActualmenteBloqueado = estadoBloqueo.codigo_modulo;
      } else {
        this.codigoModuloActualmenteBloqueado = null;
      }
    });
  }

  // private registrarTabBrowser() {
  //   try {
  //     const activeTabs = JSON.parse(localStorage.getItem(this.ACTIVE_TABS_STORAGE_KEY) || '[]');
  //     if (!activeTabs.includes(this.tabId)) {
  //       activeTabs.push(this.tabId);
  //       localStorage.setItem(this.ACTIVE_TABS_STORAGE_KEY, JSON.stringify(activeTabs));
  //     }
  //     // this.clog.log(`Tab registrada: ${this.tabId}. Pestañas activas: ${activeTabs.length}`);
  //   } catch (e) {
  //     // this.clog.log('Error al registrar pestaña:', e);
  //     localStorage.setItem(this.ACTIVE_TABS_STORAGE_KEY, JSON.stringify([this.tabId]));
  //   }
  // }
  // private quitarTabBrowserAndCheckiar(): boolean {
  //   if (!this.authService.isLoggedIn()) return false;
  //   let isLastTab = false;
  //   try {
  //     let activeTabs = JSON.parse(localStorage.getItem(this.ACTIVE_TABS_STORAGE_KEY) || '[]');
  //     activeTabs = activeTabs.filter(id => id !== this.tabId);
  //     localStorage.setItem(this.ACTIVE_TABS_STORAGE_KEY, JSON.stringify(activeTabs));
  //     isLastTab = activeTabs.length === 0;
  //     // this.clog.log(`Tab desregistrada: ${this.tabId}. Pestañas activas restantes: ${activeTabs.length}`);
  //   } catch (e) {
  //     this.clog.log('Error al quitar pestaña:', e);
  //   }
  //   return isLastTab;
  // }

}
